<template>
  <div v-show="active === ruleForm.status">
    <el-dialog :title="title" :visible.sync="dialog" :width="'40%'">
      <div class="external-integration-body">
        <p>A integração com a <b>{{ title }}</b> é configurada diretamente pela plataforma parceira, não é necessário informar credenciais aqui.</p>
        <p>Para solicitar a integração, entre em contato com o nosso suporte pelo
          <a class="external-integration-link" :href="whatsappLink" target="_blank" rel="noopener">WhatsApp</a>.</p>
        <p class="external-integration-note">O botão "Ativar integração" apenas registra que a sua loja utiliza esta integração — a ativação de fato é concluída junto ao suporte.</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" v-if="ruleForm.id" @click="remove()">Desativar integração</el-button>
        <el-button @click="dialog = false">Voltar</el-button>
        <el-button type="primary" icon="el-icon-chat-dot-round" @click="support()">Falar com suporte</el-button>
        <el-button type="success" v-if="!ruleForm.id" @click="save()">Ativar integração</el-button>
      </span>
    </el-dialog>
    <IntegrationCard :image="image" :title="title" :status="ruleForm.status" :updatedAt="ruleForm.updatedAt"
      :options="ruleForm.options" :id="ruleForm.id" @configure="configure" />
  </div>
</template>
<script>
import { i18n } from "@/plugin/i18n";
import { IntegrationService } from "@/services/customers/integration.services";
import IntegrationCard from "../components/IntegrationCard.vue";

// Integrações configuradas no lado do parceiro: o registro no banco serve
// apenas para contabilizar quais clientes utilizam a integração.
export default {
  name: "ExternalIntegration",
  props: ["customer", "active", "type", "title", "image"],
  components: { IntegrationCard },
  computed: {
    whatsappLink() {
      const message = encodeURIComponent(
        `Olá! Gostaria de solicitar a integração com a ${this.title}.`
      );
      return `https://wa.me/5511983833154?text=${message}`;
    },
  },
  methods: {
    setConfig(config) {
      const vm = this;
      vm.ruleForm.id = config.id;
      vm.ruleForm.status = config.status;
      vm.ruleForm.updatedAt = config.updatedAt;
    },
    reset() {
      const vm = this;
      vm.ruleForm = {
        id: "",
        status: false,
        options: [],
        updatedAt: "Sem registros",
      };
    },
    configure() {
      this.dialog = true;
    },
    support() {
      window.open(this.whatsappLink, "_blank");
    },
    save() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      IntegrationService.add({
        type: vm.type,
        configuration: { "gerenciada-pelo-parceiro": true },
        customer: vm.customer,
      })
        .then(() => {
          setTimeout(() => vm.$emit("refresh"), 300);
          vm.dialog = false;
          this.$message({ type: "success", message: i18n.tc("integracao-adicionado-sucesso") });
        })
        .catch((error) => this.$message({ type: "error", message: error }))
        .finally(() => loading.close());
    },
    remove() {
      const vm = this;
      this.$confirm(i18n.t("confirmar-eliminacao-integracao", { id: vm.title.toUpperCase() }),
        i18n.tc("aviso"), {
        confirmButtonText: "OK",
        cancelButtonText: i18n.tc("cancelar"),
        type: i18n.tc("aviso"),
        center: true,
      }).then(() => {
        const loading = vm.$loading(vm.$options.loading);
        IntegrationService.unregister({ customer: vm.customer, type: vm.type })
          .then(() => {
            setTimeout(() => {
              vm.$emit("refresh");
              vm.dialog = false;
            }, 300);
            this.$message({
              type: "success",
              message: i18n.tc("integracao-eliminado-sucesso"),
            });
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      });
    },
  },
  data() {
    return {
      ruleForm: {
        id: "",
        status: false,
        options: [],
        updatedAt: "Sem registros",
      },
      dialog: false,
    };
  },
};
</script>
<style scoped>
.external-integration-body {
  text-align: left;
  /* Sobrepõe o word-break: break-all herdado do el-dialog, que quebrava as
     palavras no meio (letra a letra) */
  word-break: normal;
  overflow-wrap: break-word;
}

.external-integration-body p {
  margin: 0 0 14px;
  line-height: 1.6;
  color: #606266;
}

.external-integration-link {
  color: #409eff;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}

.external-integration-body p:last-child {
  margin-bottom: 0;
}

.external-integration-body p.external-integration-note {
  font-size: 13px;
  color: #909399;
}
</style>
